import axios from 'axios'
import { useContext, useState } from 'react'
import { useHistory } from 'react-router'
import urlSearchParams from '../../components/urlSearchParams'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { UserContext } from '../../context api/UserContext'
import { formTokenHeader } from '../../lib/HeaderHelper'
import { toastMessage } from '../../shared/AlertPopup'
import { API } from '../../shared/API'
import { error, ROUTES, success } from '../../shared/constants'

export const useLeadTypeConversion = () => {
  const user = useContext(UserContext)
  const token = user && user.token
  const header = formTokenHeader(token)
  const history = useHistory()
  const [leadTypeConversion, setLeadTypeConversion] = useState(false)
  const { deleteNewLeadTypeConversion, getNewLeadTypeConversion } = useContext(ConfigurationContext)
  const [loading, setLoading] = useState(false)
  const [paginate, setPaginate] = useState(false)

  const getAllLeadTypeConversion = async (dto = {}) => {
    setLoading(true)
    axios
      .get(API.GET_ALL_LEADTYPE_CONVERSION(urlSearchParams(dto)), header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        setPaginate(data.paginate)
        getNewLeadTypeConversion(data.data)
      })
      .catch((err) => {
        setLoading(false)
        //console.log(err)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const addLeadTypeConversion = (dto) => {
    setLoading(true)
    axios
      .post(API.ADD_LEADTYPE_CONVERSION, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('Lead Type Conversion  Added Successfully', success)
        history.push(ROUTES.LEADTYPE_CONVERSION)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }
  const updateLeadTypeConversion = (dto) => {
    setLoading(true)
    axios
      .put(API.EDIT_LEADTYPE_CONVERSION, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('Lead Type Conversion  Update Successfully', success)
        history.push(ROUTES.LEADTYPE_CONVERSION)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const getLeadTypeConversion = (dto) => {
    setLoading(true)
    axios
      .get(API.GET_LEADTYPE_CONVERSION(dto.convertLeadTypeId), header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }

        setLeadTypeConversion(data.data)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const deleteLeadTypeConversion = (dto, setSelected) => {
    setLoading(true)
    axios
      .delete(API.DELETE_LEADTYPE_CONVERSION(dto.convertLeadTypeId), header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('LeadTypeConversion Deleted Successfully', success)

        deleteNewLeadTypeConversion(dto.convertLeadTypeId)
        setSelected([])
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const deleteManyLeadTypeConversion = (dto, setSelected) => {
    setLoading(true)
    axios
      .post(API.DELETE_MANY_LEADTYPE_CONVERSION, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage(`${dto.convertLeadTypeId.length} LeadTypeConversion Deleted Successfully`, success)

        dto.convertLeadTypeId.map((item) => deleteNewLeadTypeConversion(item))
        setSelected([])
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const BulkUpload = async (dto) => {
    setLoading(true)
    axios
      .post(API.BULK_UPLOAD, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        // data.data.map((item) => addNewReg(item))
        toastMessage(`${data.data.length} Data Inserted Successfully`, success)
      })
      .catch((err) => {
        setLoading(false)
        //console.log(err)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  return {
    addLeadTypeConversion,
    getAllLeadTypeConversion,
    deleteLeadTypeConversion,
    getLeadTypeConversion,
    leadTypeConversion,
    updateLeadTypeConversion,
    deleteManyLeadTypeConversion,
    BulkUpload,
    loading,
    paginate,
  }
}
